import Checkbox from 'components/Checkbox/Checkbox'
import Hand from 'components/images/hand.png'
import {
  Anchor,
  Container,
  Content,
  Heading,
  Hello,
  Para,
  Salutation,
  TermSpan,
  TermsA,
  Wrapper,
} from 'modules/Onboarding/Components/ActivateAccount/FinalPage/style'
import {
  getCollege,
  getStudentData,
  updateCurrentState,
} from 'modules/Onboarding/actions'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'

const { AUTH_URL } = process.env

const FinalPage = () => {
  let token = sessionStorage.getItem('token')
  const [checked, setChecked] = useState(true)

  const params = useParams()
  const studentId = params.studentId
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let stdData = useSelector(state => state?.studentData?.studentDetails)

  useEffect(() => {
    dispatch(getStudentData(studentId))
  }, [])

  useEffect(() => {
    if (stdData?.instituteCampusId) {
      getCollege(stdData?.instituteCampusId)
    }
  }, [stdData])

  const submitHandler = () => {
    if (checked) {
      dispatch(updateCurrentState(studentId, 2))
      navigate(`/onboarding/register/${studentId}`)
    } else {
      ErrorMessage('Please accept Terms and Conditions to continue')
    }
  }

  const handleCheck = e => {
    setChecked(e.target.checked)
  }

  useEffect(() => {
    if (token) {
      if (stdData?.currentState === 0 || stdData?.currentState === -1) {
        navigate(`/onboarding/activate/${studentId}`)
      } else if (stdData?.currentState === 2) {
        navigate(`/onboarding/register/${studentId}`)
      } else if (stdData?.currentState === 3) {
        navigate(`/onboarding/notification/${studentId}`)
      } else if (stdData?.currentState === 4) {
        window.open(AUTH_URL, '_self')
      }
    } else {
      navigate(`/onboarding/activate/${studentId}`)
    }
  }, [stdData, token])

  return (
    <Container alignCenter column>
      <Wrapper>
        <Content spaceBetween flexStart column>
          <img src={Hand} alt='hand'/>
          <Salutation flexStart column>
            <Hello>Hello {stdData?.admin?.first_name},</Hello>
            <Heading>Welcome to PluginLive</Heading>
            <Para>
              Please complete the registration process to proceed further.
            </Para>
          </Salutation>

          <div>
            <Checkbox value={checked} onChange={handleCheck} />
            <TermSpan>To proceed agree to</TermSpan>&nbsp;&nbsp;
            <TermsA
              href={'https://www.pluginlive.com/Terms_And_Conditions'}
              target="_blank"
            >
              'Terms & Conditions'
            </TermsA>
          </div>
          <Anchor onClick={() => submitHandler()}>Next</Anchor>
        </Content>
      </Wrapper>
    </Container>
  )
}

export default FinalPage
